import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import {
	saveClient,
	logEmail,
} from '../../actions/advisor';
import {
} from '../../reducers/advisor';
import s from './Step1.css';

library.add(faChevronRight, faChevronUp);

const customStyles = {
	control: (base) => ({
		...base,
		borderRadius: 0,
		boxShadow: 'none',
		height: '40px',
	}),
	option: (provided) => ({
		...provided,
		color: '#5b6770',
		fontSize: 14,
		borderRadius: 0,
		backgroundColor: 'white',
		':hover': {
			backgroundColor: '#5060F6',
			color: 'white',
		},
	}),
	menu: base => ({
		...base,
		borderRadius: 0,
	}),
	singleValue: (provided, state) => {
		const opacity = state.isDisabled ? 0.5 : 1;
		const transition = 'opacity 100ms';
		return { ...provided, opacity, transition, color: '#5b6770' };
	},
	dropdownIndicator: (base) => ({
		...base,
		color: '#5060F6',
	}),
};


class Step1 extends PureComponent {

	constructor(props) {
		super(props);
		const newClient = Object.assign({}, this.props.client);
		this.state = {
			showMore: false,
			client: newClient,
			isDirty: false,
		};
	}

	setShowMore = () => {
		const {
			showMore,
		} = this.state;
		this.setState({ showMore: !showMore });
	}

	openClientTest(client) {
		window.location = `/resource-library/behavioral-finance/?clientID=${client.id}`;
	}

	openEmail(client) {
		this.props.logEmail(client);
		const email = client.email;
		const subject = 'WisdomTree Behavioral Finance Tool';
		const body = `Client link: https://${window.location.host}/resource-library/behavioral-finance/?clientID=${client.id}`;
		window.location = `mailto:${email}?subject=${subject}&body=${body}`;
	}

	saveClient = (event) => {
		const {
			client,
		} = this.state;
		event.preventDefault();
		const newClient = Object.assign({}, this.props.client);
		newClient.laScore = client.laScore;
		this.props.saveClient(newClient).then(() => {
			this.setState(Object.assign({}, this.state, {
				isDirty: false,
			}));
			this.props.closeStep();
		});
	}

	resetClient = (event) => {
		event.preventDefault();
		const newClient = Object.assign({}, this.props.client);
		this.setState(Object.assign({}, this.state, {
			client: newClient,
			isDirty: false,
		}));
	}

	handleLAScoreChange = (value) => {
		const newClient = Object.assign({}, this.state.client);
		newClient.laScore = value.value;
		this.setState(Object.assign({}, this.state, {
			client: newClient,
			isDirty: true,
		}));
	};

	render() {
		const {
			client,
			showMore,
		} = this.state;

		const options = [
			{ value: 0, label: 'Use Client Assessment Results' },
			{ value: 1, label: 'Much Less Sensitive to Losses' },
			{ value: 1.25, label: 'Less Sensitive' },
			{ value: 1.75, label: 'About as Sensitive as Others' },
			{ value: 2.5, label: 'More Sensitive' },
			{ value: 4, label: 'Much More Sensitive' },
			{ value: 8, label: 'Extremely Sensitive to Losses' },
		];

		return (
			<React.Fragment>
				<div className="row">
					<div className={`col-md-10 ${s.introBox}`}>
						<span style={{ fontWeight: '700' }}>We highly recommend completing this assessment with each client.</span><br />
          It lets you select their highly-individualized Loss Aversion Score in step 2 based on their unique financial behavioral tendencies.
					{showMore &&
							<div>
								<br />Traditionally, identifying an appropriate portfolio for a client focuses narrowly on that client’s risk tolerance.
					However, we believe it’s not risk clients care about, but instead loss aversion.
					In other words, how much they dislike losses more than they like gains.
					At the same time, portfolio building should reflect your client’s broader set of individual
					behavioral differences such as their retirement lifestyle aspirations and more.
					<br /><br />Completing our Behavioral Financial Assessment will reveal the preferences,
					needs and tendencies that shape your clients’ most important financial decisions.
					Their answers will help you consider potential WisdomTree Models that better align
					with their behavioral tendencies and reduce short-term or emotional decision-making.
					<br /><br />The assessment takes about ten minutes. We suggest completing the survey
					with your client as it will help you understand their financial attitudes more deeply.
					You can also choose to email them the assesment to complete on their own.
					</div>
						}
					</div>
				</div>
				<div className="row">
					<div className={`col-md-10 ${s.learnMore}`} onClick={this.setShowMore}>
						{showMore &&
							<div style={{ cursor: 'pointer' }}><span style={{ textDecoration: 'underline' }}>CLOSE</span> &nbsp; <FontAwesomeIcon icon="chevron-up" size="lg" color="#5060F6" /></div>
						}
						{!showMore &&
							<div style={{ cursor: 'pointer' }}><span style={{ textDecoration: 'underline' }}>LEARN MORE</span> &nbsp; <FontAwesomeIcon icon="chevron-right" size="lg" color="#5060F6" /></div>
						}
					</div>
				</div>
				<div className="row">
					<div className={`col-md-10`}>
						<div className={`${s.rowLine}`} />
					</div>
				</div>
				<div className="row" style={{ marginTop: '45px' }}>
					<div className={`col-md-10`}>
						<div className={s.clientAction} onClick={() => this.openClientTest(client)}>COMPLETE ASSESSMENT WITH CLIENT</div>
						<div className={s.actionOr}>OR</div>
						<div className={s.clientAction} onClick={() => this.openEmail(client)}>EMAIL ASSESSMENT TO CLIENT</div>
					</div>
				</div>
				<div className="row" style={{ marginTop: '60px' }}>
					<div className={`col-md-6`}>
						<div className={s.formTitle}>Risk Tolerance</div>
					</div>
				</div>
				<div className="row" style={{ marginTop: '15px' }}>
					<div className={`col-md-6`}>
						<div className={s.formLabel}>Loss Aversion Score/Risk Tolerance*</div>
					</div>
				</div>
				<div className="row" style={{ marginTop: '5px' }}>
					<div className={`col-md-6`}>
						<Select
							options={options}
							styles={customStyles}
							value={options.find(item => item.value === client.laScore)}
							onChange={this.handleLAScoreChange}
						/>
					</div>
					<div className={`col-md-6`}>
						<div className={s.formNote}>* Select "Use Client Assessment Results" if you completed Step 1.
					<br />&nbsp;&nbsp;If not, select what you feel is the client's risk tolerance.</div>
					</div>
				</div>
				<div className="row" style={{ marginTop: '60px' }}>
					<div className={`col-md-12`} style={{ textAlign: 'center' }}>
						<div className={s.saveButton} onClick={this.saveClient}>SAVE</div>
						<div className={s.cancelButton} onClick={this.resetClient}>CANCEL</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

function mapStateToProps(state) {
	return {
	};
}

export default connect(mapStateToProps, {
	saveClient,
	logEmail,
})(Step1);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/Step1.js